import { axios } from '@/services/axios';

const getCustomSIPHeaderByID = async (customHeaderID, currentScope) => {
    const res = await axios.get(`/TRECustomHeader/${customHeaderID}`, {
        headers: {
            'X-RequestScope': currentScope,
        },
    });
    return res.data;
};

export default getCustomSIPHeaderByID;
